import { render } from "./asignacion.vue?vue&type=template&id=314e7343&scoped=true"
import script from "./asignacion.vue?vue&type=script&lang=js"
export * from "./asignacion.vue?vue&type=script&lang=js"

import "./asignacion.vue?vue&type=style&index=0&id=314e7343&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314e7343"]])

export default __exports__